/* eslint-disable */
const spdengine = (window as any).spdengine;
console.log(spdengine.Scott.create, window);

class ModelOperation {
    modelGroupId: string
    file: any
    modelPathArray: any
    totalChunk: number
    chunkSize: number
    bench: string
    api: any
    componentIds: string[]
    constructor (file, modelGroupId: string) {
        this.modelGroupId = modelGroupId;
        this.file = file;
        this.modelPathArray = [];
        this.totalChunk = Math.ceil(file.size / 1045671);
        this.chunkSize = 1045671;
        this.bench = '';
        this.api = null;
        this.componentIds = [];
    }

    // 模型的点击事件
    modelClickHandle (bench, parentSelf, compIds?) {
        console.log(compIds);
        let api = spdengine.Apis.getApi(bench)['3D'];
        var self = this;
        self.componentIds = compIds;
        console.log('点击模型事件');
        api.addSelectEventListener('click', function (ev) {
            console.log(ev);
            operation (ev);
            

            // selectOperation(ev);
        });
        // 框选事件添加
        api.addSelectEventListener('region', function (ev) {
            operation (ev);
        });

        function selectOperation(ev) {
            console.log(ev);
            let rebarHandle = parentSelf.$store.state.RebarHandle.concat(parentSelf.$store.state.xjRebarHandle);
            let rebarHand: any[] = [];
            if (rebarHandle) {
                rebarHandle.forEach((r, i) => {
                    rebarHand.push(r.handle);
                });
            }
            if (rebarHand.indexOf(ev.handle) === -1) {
                operation (ev);
            } else {
                console.log('钢筋');
                console.log(ev.handle);
            }
        }

        function operation (ev) {
            if(self.componentIds && self.componentIds.length > 0){
                // self.transparencyComponents(bench, self.componentIds);
            }
            let clickGroupIds: any[] = []; // 选中的id
            if (ev.uuids.length !== 0) {
                ev.uuids.forEach(e => {
                    clickGroupIds.push(spdengine.btoa(e));
                });
            }
            console.log(clickGroupIds);
            parentSelf.$store.commit('clickGroupIds', clickGroupIds);
        }
    }
    // 模型联动
    modelLinkage (bench, items, myIdx) {
        console.log(items);
        if(items.filter((i) => i.threeDModel).length === 1) return;
        let api = spdengine.Apis.getApi(bench)['3D'];
        api.addEventListener("control_update", (ev) => {
            items.forEach((e,idx) => {
                if(idx !== myIdx && e.modelPath){
                    if(!spdengine.Apis.getApi(e.bench)) return;
                    let leftApi3d = spdengine.Apis.getApi(e.bench).D3;
                    let leftPos = leftApi3d.getProjectPositionRef();
                    leftPos.x += ev.params.posDelta[0];
                    leftPos.y += ev.params.posDelta[1];

                    let leftCenter = leftApi3d.getProjectRotationCenterRef();
                    leftCenter.x += ev.params.centerDelta[0];
                    leftCenter.y += ev.params.centerDelta[1];
                    leftCenter.z += ev.params.centerDelta[2];

                    let leftRotation = leftApi3d.getProjectRotationRef();
                    leftRotation.x += ev.params.rotationDelta[0];
                    leftRotation.y += ev.params.rotationDelta[1];
                    leftRotation.z += ev.params.rotationDelta[2];

                    let leftCamera = leftApi3d.getBenchCamera();
                    leftCamera.zoom *= ev.params.zoomDelta;

                    (leftApi3d as any).controlUpdate(false);
                }
            });
        })
        api.addEventListener("clearHighlight", (ev) => { // 清除选择
            items.forEach((e,idx) => {
                if(idx !== myIdx && e.modelPath){
                    spdengine.Apis.getApi(e.bench)['3D'].clearHighlight(true);
                }
            });
        })
        api.addEventListener("showAll", (ev) => { // 全部显示
            const myLook = api.getCurrentViewpoint();
            items.forEach((e,idx) => {
                if(idx !== myIdx && e.modelPath){
                    spdengine.Apis.getApi(e.bench)['3D'].showAll();
                }
            });
        })
    }
    // 清空被选中和高亮构件
    clearGroup (bench) {
        let api = spdengine.Apis.getApi(bench)['3D'];
        api.clearHighlight(true);
    }

    // 高亮构件
    chooseHighlight (bench, ids, infos, groupName) {
        let api = spdengine.Apis.getApi(bench)['3D'];
        ids.forEach(e => {
            api.highlightComponent(spdengine.atob(e));
        });
        if(infos) {
            const Case = spdengine.Case;
            const Vector23D = spdengine.Vector23D;
            const MakerLineState = spdengine.MakerLineState;
            const _Math = spdengine._Math;
            let offset = new Vector23D(40, -40);
            const info = { lineState: MakerLineState.POLYLINE, state: 0, deviceId: _Math.generateUUID(), isOutterFlicker: true, subLineRadian: Math.PI / 2, subLineLength: 10,
                customColor: '#FFFFFF8F', pointOffset: offset, circleNumber: 2, intersectionRatio: 3 / 20, outterInsterval: 2 };
            new Case(infos, groupName, ids, spdengine.Apis.getApi(bench), info);
        }
    }

    // 显示指定构件，同时隐藏其它构件
    isolateComponents (bench, compIdList, inquire?) {
        let api = spdengine.Apis.getApi(bench)['3D'];
        let engineApi = spdengine.Apis.getApi(bench).engine;
        api.clearHighlight();
        api.hiddenAll();
        this.componentIds = [];
        if (compIdList && compIdList.length > 0) {
            let compIds: any[] = [];
            for (let i = 0; i < compIdList.length; i++) {
                compIds.push(spdengine.atob(compIdList[i]));
            }
            api.setRenderState(compIds, 2);
            inquire && this.focusByBoundingBox(api, compIdList, false)
        }
        engineApi.updateView(0);
    }
    // 聚焦
    focusByBoundingBox (api, compIdList, val) {
        if(val) api = spdengine.Apis.getApi(api)['3D'];
        setTimeout(() => { // 反查需要等添加完canvas再聚焦
            let box = null;
            compIdList.forEach(e => {
                box = api.getElementBoundingBox(e, box);
            });
            api.focusByBoundingBox(box); //聚焦
        }, 100);
    }
    resize (bench) {
        let api = spdengine.Apis.getApi(bench) && spdengine.Apis.getApi(bench)['UI'];
        api.resizeBench();
    }

    createBench (model, self, l_l_l, is2D, myIdx) {
        let _this = this;
        let container = document.getElementById(l_l_l);
        self.$store.commit('modelProgress', 0);
        const bench = spdengine.Scott.create({
            'container': container,
            'projectId': _this.modelGroupId,
            'dock': 4,
            tooBarState: false,
            // eslint-disable-next-line no-undef
            'system': is2D ? spdengine.SystemType.ST_2D_WSM : spdengine.SystemType.ST_3D_WSM,
            engineSrcPath: '/static/',
            alpha: true,
            envInitSuccessCB: () => {
                _this.resize(bench);
                spdengine.Scott.run(bench);
                const PARAMS = spdengine.Apis.getApi(bench).PARAMS;
                // eslint-disable-next-line no-undef
                const host = process.env.NODE_ENV === 'production' ? 'https://cdn.spdspd.com/' : 'http://file.dev.spdio.com/';
                spdengine.Scott.load(bench, {
                    url: (l_l_l === 'home_model' ? 'https://cdn.spdspd.com/' : host ) + model.modelPath,
                    workerUrl: location.origin + '/static/',
                    orgModelId: 1,
                    newModelId: 1,
                    modelMatrix: new spdengine.Matrix43D()
                });
                let api = spdengine.Apis.getApi(bench)['3D'];
                api.addEventListener('fileloader_geomallloadend', (result) => { // 整个模型都加载完成之后会出发的事件
                    console.log('运行bench'+bench+l_l_l);
                    self.$store.commit('modelLoadComplete', true);
                    // 点击事件监听
                    _this.modelClickHandle(bench, self);
                    if(l_l_l === 'home_model') api.runLoopRotationAnimation(1, 0.01); // 旋转
                    if(l_l_l !== 'home_model') {
                        _this.modelLinkage(bench, self.items, myIdx);
                        const viewpoint = spdengine.Apis.getApi(bench).getCurrentViewpoint();
                        if(!is2D) {_this.create3DAxis(api);};
                        spdengine.Apis.getApi(bench).setCurrentViewpoint(viewpoint);
                    }
                });
                api.addEventListener('fileloader_geomloadend', (result) => { // 模型的一个文件加载完成之后会触发的事件
                    if(l_l_l === 'home_model' && result.params.current === 1) {
                        let timer = setTimeout(()=>{
                        // spdengine.Apis.getApi(bench).setCurrentViewpoint('eyJwb3MiOlstMTMuNzc0NjE5Mjg4NzMzMjMsNC43MjkyMzg3Mjc3NjUxNjcsLTIzOC41MzIxMzM4NjkzODEzXSwiY2VudGVyIjpbLTUuOTMyNTI1NjM0NzY1NjI1LC0zMi43Mzg2MTY5NDMzNTkzNzUsLTE2LjA0MDAyNTcxMTA1OTU3XSwicm90YXRlIjpbMCwtMS4xNzQ0NDk4ODUyMDQyMzQ5LC0wLjQ5Njg1MTQ2OTcyNDA4MjFdLCJ6b29tIjoxNC4xODAwNjgwMDE2Mjc4NjQsInN5cyI6NjR9');
                        // eyJwb3MiOlsxMC4zMDc3NzM1Mzg0MTc1ODMsMTIuNTAxOTg1MzY5Mzg5Nzc1LC0yMzcuOTI1MjI2ODgxNzgzMV0sImNlbnRlciI6Wy02LjkzMzM3Mjk3NDM5NTc1MiwtNS42OTE2NjA4ODEwNDI0ODA1LC0wLjE2NDA2MjVdLCJyb3RhdGUiOlswLC0wLjgzMjMzNzY0ODA4Mjg4ODUsMi40Mjk1ODUyMjg0MjU2Nzg3XSwiem9vbSI6OS45MTg0NDcwOTk1ODQ5MTEsInN5cyI6NjQsImNhbWVyYVR5cGUiOjF9
                        spdengine.Apis.getApi(bench).setCurrentViewpoint('eyJwb3MiOlstMjQuNjI0MDk1NDc0MTA4OTI3LDkuODUxMTA4Nzk0OTMzNzMxLC0yMzcuOTI1MjI2ODgxNzgzMV0sImNlbnRlciI6Wy0xMS4zMzAyNzM2MjgyMzQ4NjMsLTI5Ljg1NTY1MTg1NTQ2ODc1LC0yMy40MzgyMzI0MjE4NzVdLCJyb3RhdGUiOlswLC0xLjAyNjgwMTIyNzQ5Mzk5NTUsMS41OTcxMTYwNDMwODM3MzhdLCJ6b29tIjoxMi4xNzcyNTEwNjQxNjkxMzYsInN5cyI6NjQsImNhbWVyYVR5cGUiOjF9')
                        clearTimeout(timer);
                        },10)
                        spdengine.Apis.getApi(bench)['UI'].setMenuState(false); // 关闭菜单
                    }
                    if (result.params.current === result.params.totial) {
                        console.log(result);
                        self.$store.commit('modelProgress', 100);
                        setTimeout(function () {
                            let engineApi = spdengine.Apis.getApi(bench).engine;
                            engineApi.updateView(0);
                        }, 10);
                    } else {
                        self.$store.commit('modelProgress', result.params.current * 100 / result.params.totial);
                    }
                });
                if(l_l_l === 'home_model') {
                    PARAMS.rd_continue = true; //强制渲染
                    PARAMS.material_state = 'purecolor'; // 纯色模式
                    PARAMS.eg_pureColor = 0xffffff91; // 构件颜色
                    PARAMS.eg_wireframeColor = 0xffffffe6; // 线框颜色
                    PARAMS.hl_enableClick = false; // 关闭单机高亮
                    PARAMS.spd_logoEnable = false; // 关闭logo
                    PARAMS.bc_enable = false; // 禁止鼠标操作
                    PARAMS.df_enable = false; // 禁止双击 
                    PARAMS.eg_clearColor = 0x0; // 背景色透明
                } else {
                    _this.getDefaultBg(api);
                }
                if (self.$route.name === 'Compare') {
                    PARAMS.spd_logoEnable = !self.$store.state.isMobile; // 关闭logo
                }
                PARAMS.hl_highlightColor = 0x02d6dce6; // 高亮色
                PARAMS.sr_enable = false;  // 去掉阴影
                PARAMS.ng_enable = false; // 关闭导航仪
            }
        });
        return bench;
    }
    create3DAxis (api3d) { // 创建三维轴线
        let box = api3d.getModelBoundingBox(1);
        let size = box.getSize();  // 获取模型boundingbox的大小
        const Vector33D = spdengine.Vector33D;
        let halfSize = new Vector33D(-size.x * 0.55, -size.y * 0.55, size.z * 0.5); // 获取坐标轴起点与包围盒中心偏移值
        let startPoint = new Vector33D();
        startPoint.subVectors(box.getCenter(), halfSize);  // 获取坐标轴起点
        let line1 = {  startPoint: startPoint, endPoint: new Vector33D(startPoint.x, startPoint.y, startPoint.z + size.z * 0.1) }
        let lineParam1 = { line: line1, color: 0x329532ff };
        api3d.createLine(lineParam1);
        let line2 = {  startPoint: startPoint, endPoint: new Vector33D(startPoint.x, startPoint.y - size.y * 0.1, startPoint.z) }
        let lineParam2 = { line: line2, color: 0x45458Eff };
        api3d.createLine(lineParam2);
        let line3 = {  startPoint: startPoint, endPoint: new Vector33D(startPoint.x - size.x * 0.1, startPoint.y, startPoint.z) }
        let lineParam3 = { line: line3, color: 0x913A3Aff };
        api3d.createLine(lineParam3);
    }
    getDefaultBg(api) {
        const cfgLinearGradient = [
            { stop: 0, color: "#23313E" },
            { stop: 1, color: "#0F1014" },
        ];

        const width = 1920;
        const height = 1080;
        const canvas = document.createElement('canvas');
        canvas.setAttribute('width', width.toString());
        canvas.setAttribute('height', height.toString());
        const ctx:any = canvas.getContext('2d');
        const grad = ctx.createRadialGradient(width/2, height/2, 5, width/2, height/2, 800);
        for (const item of cfgLinearGradient) {
            grad.addColorStop(item.stop, item.color);
        }
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, width, height);
        const data = ctx.getImageData(0, 0, width, height);
        api.setBackgroundImageData(data.data, data.width, data.height);
        return data;
    }
    destroy (bench) {
        spdengine.Scott.destroy(bench);
    }
}

export default ModelOperation;
